module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-radio.b83b3a99.png";